import axios from 'axios';
import { API_URL } from '../env';
import { normalize } from './helpers';

/** The playable cards; `everything`: every card of every set, for looking cards up (`enabled` says which play). */
async function all({ everything = false } = {}) {
  const response = await axios.get(`${API_URL}/cards`, { params: everything ? { all: 1 } : {} });

  return normalize(response.data);
}

export {
  all,
};
